import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'

import { CardNotificationBase } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import { PRAKTIK_KINERJA_STEPS } from 'app/KinerjaGpkPage/constants/praktik-kinerja-steps'
import { PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'

import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import type { TPelaksanaanAppealableStep } from 'types/kinerja-pelaksanaan'

type CardNotificationGpkPelaksanaanAppealResultProps =
  CardNotificationBaseProps & {
    isApproved: boolean
    step: TPelaksanaanAppealableStep
  }

export function CardNotificationGpkPelaksanaanAppealResult({
  isApproved,
  step,
  ...cardProps
}: CardNotificationGpkPelaksanaanAppealResultProps) {
  if (!isApproved) {
    return <CardNotificationBase {...cardProps} />
  }

  return (
    <CardNotificationBase {...cardProps}>
      <div className="mt-6">
        <Link
          href={
            PRAKTIK_KINERJA_STEPS[step]?.getPath() ??
            PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH
          }
          passHref
        >
          <Button as="a" className="!inline-flex" size="sm" type={undefined}>
            Cek Pengisian
          </Button>
        </Link>
      </div>
    </CardNotificationBase>
  )
}
